import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '@env';
export const authCodeFlowConfig: AuthConfig = {
  issuer: environment.idProvider,
  redirectUri: window.location.origin + '/#/customers',
  clientId: environment.keycloakClientId,
  responseType: 'code',
  scope: 'openid profile email',
  showDebugInformation: true,
  disableAtHashCheck: true,
  requireHttps: false,
};
